import { useMutationAddNewTagToReports } from 'api/mutations/AddMultipleReportTags.mutation';
import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

export const usePrepareFormTagsForSetReportPayload = () => {
    const { mutateAsync: addNewTags } = useMutationAddNewTagToReports();
    // get tags that needs to be created -> they don't exist in DB yet
    const getNewTags = async (tags: Tag[]) => {
        const nonExistingTags = tags.filter((tag) => typeof tag.id !== 'number').map((tag) => tag.name);
        try {
            if (nonExistingTags.length > 0) {
                const newTags = await addNewTags(nonExistingTags);
                if (!newTags || newTags?.data?.length === 0) return [];
                return newTags.data;
            } else {
                return [];
            }
            // in case the API failed then return empty array
        } catch (err) {
            return [];
        }
    };

    const mergeTags = (selectedTags: Tag[], newTags: Tag[]) => {
        const existingTags = selectedTags.filter((tag) => typeof tag.id === 'number');
        const mergedTags = [...existingTags, ...newTags];
        return mergedTags;
    };

    const getTagsPayloadForReport = async (selectedTags: Tag[]) => {
        // return empty array if there are no tags.
        if (selectedTags.length === 0) return [];
        // check if we have Tags that need to be created, if so then create them and return the created tags.
        const newTags = await getNewTags(selectedTags);

        // The merge prevents us from sending invalid data format to BE
        const selectedTagsPayload = mergeTags(selectedTags, newTags);
        return selectedTagsPayload;
    };

    return {
        getTagsPayloadForReport,
    };
};
